import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetCompany, adminGetAllCompanies, resetFocusCompany } from "services/company";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import GeneralForm from "features/Admin/Companies/Forms/GeneralForm";
import { Form, Formik } from "formik";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { getGeslabImport } from "services/geslab";

class CompaniesAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusCompany();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllCompanies();
	};

	focusOnElement = (elt) => {
		this.props.adminGetCompany(elt);
	};

	render() {
		const { companies } = this.props;
		const { focus, list } = companies;
		const company = focus.data;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={companies.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="SOCIÉTÉS"
					defaultLabel={(e) => e.name}
					groupField={false}
					focusedEltId={company}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Sociétés"
					icon="info"
					actionsFunction={[
						async () => {
							await this.props.getGeslabImport().then(() => this.props.adminGetAllCompanies());
						},
					]}
					actionsButton={[
						<>
							<Icon name="download" />
							Importer les sociétés
						</>,
					]}
				>
					{company !== null && (
						<Formik
							initialValues={{
								id: company.id,
								name: company.name || "",
								sil_id: company.sil_id || "",
								type: company.type || "",
								department: company.department || "",
								address: company.address || "",
								postal_code: company.postal_code || "",
								city: company.city || "",
								phone1: company.phone1 || "",
								phone2: company.phone2 || "",
								phone3: company.phone3 || "",
								fax1: company.fax1 || "",
								fax2: company.fax2 || "",
								fax3: company.fax3 || "",
								disabled: company.disabled || false,
							}}
						>
							<Form>
								<Grid style={{ margin: 0 }}>
									<Grid.Row columns={1}>
										<Grid.Column>
											<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusCompany}>
												Fermer
											</SecondaryButton>
										</Grid.Column>
									</Grid.Row>
									<Grid.Row columns={1}>
										<Grid.Column>
											<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
												<GeneralForm />
											</AdminDataContainer>
										</Grid.Column>
									</Grid.Row>
								</Grid>
							</Form>
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		companies: state.admin.companies,
	};
};

const mapDispatchToProps = {
	adminGetAllCompanies,
	adminGetCompany,
	resetFocusCompany,
	getGeslabImport,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesAdmin);
